import { FC, Fragment } from 'react';

import { CheckIcon } from 'ui/components/icon';
import { cn } from 'utils/helpers';

type StepperProps<T> = {
  steps: { label: string; value: T }[];
  activeStepValue: T;
};

type StepperBaseProps = {
  stepNumber: number;
  stepLabel: string;
  isChecked: boolean;
  isActive: boolean;
};

const StepperBase: FC<StepperBaseProps> = ({
  stepNumber,
  stepLabel,
  isChecked,
  isActive,
}) => {
  return (
    <div className="flex flex-1 gap-2 items-center group">
      <div
        className={cn(
          'text-xs',
          'rounded-full',
          'shrink-0',
          'w-[26px]',
          'h-[26px]',
          isActive || isChecked
            ? 'bg-primary-base text-fill-tertiary font-semibold'
            : 'bg-fill-primary text-content border-[0.5px] border-secondary-lighter',
          'flex',
          'items-center',
          'justify-center',
        )}
      >
        {isChecked ? (
          <CheckIcon className="w-3 h-3 text-fill-tertiary" />
        ) : (
          stepNumber
        )}
      </div>
      <div className="font-semibold text-xs leading-5 tracking-wider">
        {stepLabel}
      </div>
    </div>
  );
};
const BasicStepper = <T,>({ steps, activeStepValue }: StepperProps<T>) => {
  return (
    <div className="p-[10px] flex gap-2 w-full items-center">
      {steps.map((step, index, arr) => {
        const isActive = activeStepValue === step.value;
        const activeStepIndex = arr.findIndex(
          (v) => v.value === activeStepValue,
        );
        return (
          <Fragment key={step.value as string}>
            <StepperBase
              isActive={isActive}
              isChecked={index < activeStepIndex}
              stepLabel={step.label}
              stepNumber={index + 1}
              key={index}
            />
            {index < arr.length - 1 && (
              <div className="group-last:hidden border-t w-full border-separator-primary"></div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default BasicStepper;
